<template>
  <div
    class="sections-scroller"
    :style="{ transform: `translateY(-${offsetY}px)` }"
  >
    <slot />
  </div>
</template>

<script>
import Hammer from 'hammerjs'
import {
  mapActions, mapMutations, mapGetters, mapState,
} from 'vuex'
import windowHeightMeasurer from '@/scripts/helpers/windowHeightMeasurer'
import debounce from '@/scripts/lib/debounce'

export default {
  name: 'SectionScroller',
  data() {
    return {
      offsets: [],
    }
  },
  computed: {
    ...mapGetters([
      'isBirthDateValid',
    ]),
    ...mapState([
      'currentSection',
    ]),
    offsetY() {
      return this.offsets[this.currentSection]
    },
  },
  created() {
    this.wheelHandler = debounce(this.wheelHandler, 100)
  },
  mounted() {
    this.sections = Array.from(this.$el.querySelectorAll('.section')).map((section, index) => ({
      el: section,
      index,
      keepOwnHeight: !!section.dataset.keepOwnHeight,
    }))

    this.setSectionsCount(this.sections.length)
    this.setSectionHeights()
    this.attachSwipeEvents()

    window.addEventListener('resize', this.setSectionHeights)

    window.addEventListener('wheel', this.wheelHandler)
  },
  methods: {
    ...mapActions([
      'changeSectionBack',
      'changeSectionForward',
    ]),
    ...mapMutations([
      'setSectionsCount',
      'setSectionsHeights',
    ]),
    attachSwipeEvents() {
      const hammerTime = new Hammer(this.$el)

      hammerTime.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL })

      hammerTime.on('swipedown', () => this.changeSectionBack())
      hammerTime.on('swipeup', () => this.changeSectionForward())
    },
    setSectionHeights() {
      const offsets = []
      const windowHeight = windowHeightMeasurer()

      this.sections.forEach(({ el, index, keepOwnHeight }) => {
        let height = windowHeight

        if (keepOwnHeight) {
          height = el.scrollHeight
        }

        el.setAttribute('style', `height: ${height}px`)

        if (index) {
          offsets[index] = height + offsets[index - 1]
        } else {
          offsets[index] = 0
        }
      })

      this.offsets = offsets
    },
    wheelHandler({ deltaY }) {
      if (deltaY > 0) {
        this.changeSectionForward()
      } else {
        this.changeSectionBack()
      }
    },
  },
}
</script>
